export default "__VITE_PUBLIC_ASSET__a1d0df2c__"